module.exports = __webpack_public_path__ + "img/Button-kosik-2021-05.cc4852a9.png";